import { useApplicationContext } from '../utils/applicationContext';

export function useIsWebView() {
  const { config } = useApplicationContext();

  return Boolean(config.get<boolean>('web.isWebView'));
}
